import { lazy } from "react";

const HomeScreen = lazy(() => import("screens/MainPage/HomeScreen"));
const ProductScreen = lazy(() => import("screens/MainPage/ProductScreen"));
const AboutUsPage = lazy(() => import("screens/MainPage/AboutUsPage"));
const Catalog = lazy(() => import("screens/MainPage/Catalog"));
const Promotions = lazy(() => import("screens/MainPage/Promotions"));
const QuotationPage = lazy(() => import("screens/MainPage/QuotationPage"));
const Rates = lazy(() => import("screens/MainPage/RatesScreen"));
const Privacy = lazy(() => import("screens/MainPage/Privacy"));
export const routes = [
  {
    path: "/",
    pathWithoutParams: "/",
    isIndex: true,
    exact: true,
    component: HomeScreen,
    navbar: true,
    label: "Inicio",
  },
  {
    path: "/circuito/:id?/",
    pathWithoutParams: "/circuito",
    isIndex: false,
    exact: true,
    component: ProductScreen,
    navbar: false,
    label: "Producto",
  },
  {
    path: "/sobrenosotros/",
    pathWithoutParams: "/sobrenosotros",
    isIndex: false,
    exact: false,
    component: AboutUsPage,
    navbar: true,
    label: "Nosotros",
  },
  {
    path: "/vuelos/:type?/",
    pathWithoutParams: "/vuelos",
    isIndex: false,
    exact: false,
    component: Catalog,
    navbar: false,
    label: "Vuelos",
  },
  {
    path: "/tarifas/",
    pathWithoutParams: "/tarifas",
    isIndex: false,
    exact: false,
    component: Rates,
    navbar: true,
    label: "Tarifas",
  },
  {
    path: "/cotizar/vuelos",
    pathWithoutParams: "/cotizar/vuelos",
    isIndex: false,
    exact: false,
    component: QuotationPage,
    navbar: true,
    label: "Vuelos",
  },
  {
    path: "/privacidad/",
    pathWithoutParams: "/privacidad",
    isIndex: false,
    exact: false,
    component: Privacy,
    navbar: true,
    label: "Privacidad",
  },
];
